module.exports = __webpack_public_path__ + "img/product-placeholder-76.ac5c846.png";